module.exports = __webpack_public_path__ + "img/Professional-3.a69ff5b7.png";